import { State, initialState } from "@/mk2/apps/bazaar/containers/IsSoldPoll/IsSoldPoll.reducers";
import { AppState } from "@/mk2/reducers";

export const getIsSoldPollState = (state: AppState): State =>
    state.containers.bazaar.isSoldPoll || initialState;
